import { Button, Table } from 'antd'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { UserAddOutlined } from '@ant-design/icons'
import PageLayout from '@BUP/components/Layout/Page'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import ModalComponent from '@BUP/components/Generics/Modal'
import AddUsersFormWithNoCourse from '@BUP/components/MySchool/AddUsersFormWithNoCourse'
import { useResetPassword } from '@BUP/hooks/user/useResetPassword'
import { useGetEnrollmentsByRoleType } from '@BUP/hooks/Enrollments/useGetEnrollmentsByRoleType'
import { useCreateEnrollmentWithNoCourse } from '@BUP/hooks/user/useCreateEnrollmentWithNoCourse'
import styles from './assistant_page.module.scss'
import BupSpinner from '@BUP/components/Loading/Spinner'

const AssistantPage = () => {
  const { onPasswordReset } = useResetPassword()
  const organization = useContext(OrganizationContext)
  const i18n = useTranslation()
  const organizationId = organization && organization.id
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const { data, totalCount, loading, fetching, getEnrollments } = useGetEnrollmentsByRoleType(
    organizationId,
    'ASSISTANT',
    {
      page: currentPage,
      limit: pageSize
    }
  )
  const {
    isModalOpen,
    setIsModalOPen,
    createEnrollment,
    error,
    loading: loadingCreateEnrollment
  } = useCreateEnrollmentWithNoCourse(getEnrollments)

  const columns = [
    {
      title: i18n.t('common.resources.user.attributes.name.label'),
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: i18n.t('common.resources.user.attributes.email.label'),
      dataIndex: 'email',
      align: 'center'
    },

    {
      title: i18n.t('common.resources.generic.actions.any.reset').toUpperCase(),
      dataIndex: 'resetPassword',
      align: 'center',
      render: (text, info) => {
        const { email } = info
        return (
          <Button
            style={{ fontWeight: 'bold' }}
            type='primary'
            shape='round'
            onClick={() => onPasswordReset(email)}
          >
            {i18n.t('common.resources.user.actions.create.password.submit')}
          </Button>
        )
      }
    }
  ]

  const dataAssistantsList =
    (data ?? []).map(assistant => ({
      key: assistant.id,
      name: assistant.user.name,
      email: assistant.user.email
    }))

  const handleAssistantsPaginationChange = (page, nextPageSize) => {
    setPageSize(nextPageSize)
    setCurrentPage(nextPageSize !== pageSize ? 1 : page)
  }

  const totalAssistants = totalCount ?? dataAssistantsList.length

  if (loading) return <BupSpinner size='large' />

  return (
    <PageLayout
      pageName={i18n.t('common.resources.role.values.type.assistant', { count: 2 })}
      backButton
    >
      <div style={{ alignSelf: 'flex-end', padding: 10 }}>
        <ButtonComponent
          colorType='secondary'
          buttonText={<UserAddOutlined style={{ width: 90, fontSize: 20, display: 'flex', justifyContent: 'center' }} />}
          onClick={() => setIsModalOPen(true)}
        />
      </div>
      <Table
        loading={fetching}
        columns={columns}
        dataSource={dataAssistantsList}
        bordered
        pagination={{
          position: ['none', 'bottomCenter'],
          current: currentPage,
          pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', String(totalAssistants)],
          total: totalAssistants,
          onChange: handleAssistantsPaginationChange
        }}
        className={styles.table}

      />
      <ModalComponent
        header
        headerText={i18n.t('common.resources.user.actions.add.submit')}
        modalDescription={
          <AddUsersFormWithNoCourse
            createEnrollment={createEnrollment}
            error={error}
            roleType='assistant'
            loading={loadingCreateEnrollment}
          />
        }
        stateModal={isModalOpen}
        showButtons={false}
        onClickCloseModal={() => setIsModalOPen(false)}
      />
    </PageLayout>
  )
}

export default AssistantPage
